import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfirmService } from '../../../../core/services/confirm.service';
import { BrandButtonComponent } from '../../brand-button/brand-button.component';
import { ModalComponent } from '../modal/modal.component';

/** Renders the pending confirmation. Mounted once in app.component. */
@Component({
  selector: 'app-confirm-host',
  imports: [ModalComponent, BrandButtonComponent],
  template: `
    @let options = confirmService.current();
    <app-modal [open]="!!options" [title]="options?.header || ''" widthClass="max-w-md" (closed)="confirmService.reject()">
      <div class="flex items-start gap-3">
        @if (options?.icon) {
          <i class="mt-0.5 text-xl text-[var(--tenant-accent)]" [class]="options?.icon"></i>
        }
        <p class="m-0 text-sm leading-6 text-slate-600 dark:text-slate-300">{{ options?.message }}</p>
      </div>

      <div modal-footer class="flex flex-wrap justify-end gap-2">
        <app-brand-button variant="outline" size="sm" iconHover="none"
          [label]="options?.rejectLabel || 'Cancel'"
          (btnClick)="confirmService.reject()"></app-brand-button>
        <app-brand-button variant="filled" size="sm" iconHover="none"
          [tone]="options?.tone === 'danger' ? 'danger' : 'brand'"
          [label]="options?.acceptLabel || 'OK'"
          (btnClick)="confirmService.accept()"></app-brand-button>
      </div>
    </app-modal>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmHostComponent {
  confirmService = inject(ConfirmService);
}
